import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { catchError, Observable, of } from 'rxjs';
import { Globals } from '../../globals';
import { Translation } from './translation.interfaces';

@Injectable({
  providedIn: 'root',
})
export class TranslationsService implements TranslateLoader {
  private readonly http = inject(HttpClient);
  private readonly globals = inject(Globals);

  /**
   * this is and extension on the Translate loader if you set 1 it will use the langauge with id 1 for public translations id you send client or admin it will use the languages with those types from the api
   * @param lang Translation.set("") is the language param send to here - use: type_langId
   */
  getTranslation(lang: string): Observable<any> {
    // allowed requests: client_languageId, admin_languageId, public_languageId
    if (lang.startsWith('client')) {
      return this.GetClientTranslations();
    }

    if (lang.startsWith('admin')) {
      return this.GetAdminTranslations();
    }

    const langSplit = lang.split('_');

    // Get the the translations for the Installer Dashboard (IDB) public pages
    if (lang.startsWith('publicidb')) {
      if (langSplit.length !== 2) {
        return this.GetPublicIDBTranslations(1);
      }
      return this.GetPublicIDBTranslations(Number(langSplit[1]));
    }

    if (langSplit.length !== 2) {
      return this.GetPublicTranslations(1);
    }

    return this.GetPublicTranslations(Number(langSplit[1]));
  }

  /**
   * Gets all the translations for the client applications
   */
  GetClientTranslations(): Observable<Translation> {
    return this.http
      .get<Translation>(`${this.globals.apiRoot}/jwtTranslations/client`)
      .pipe(catchError(() => of({} as Translation)));
  }

  /**
   * gets all the translations for the admin application
   */
  GetAdminTranslations(): Observable<Translation> {
    return this.http.get<Translation>(
      `${this.globals.apiRoot}/jwtTranslations/admin`,
    );
  }

  /**
   * Gets the the translations for the public pages
   * @param id  the id of the language from the language service
   */
  GetPublicTranslations(id: number): Observable<Translation> {
    return this.http.get<Translation>(
      `${this.globals.apiRoot}/jwtTranslations/public/${id}`,
    );
  }

  /**
   * Get the the translations for the Installer Dashboard (IDB) public pages
   * @param id  the id of the language from the language service
   */
  GetPublicIDBTranslations(id: number): Observable<Translation> {
    return this.http.get<Translation>(
      `${this.globals.apiRoot}/jwtTranslations/publicidb/${id}`,
    );
  }
}
